(function () {
  const STORAGE_KEY = 'hakeem_quote_pending_booking';

  function safeParse(raw) {
    try {
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }

  function escapeHtml(text) {
    const d = document.createElement('div');
    d.textContent = text ?? '';
    return d.innerHTML;
  }

  function findBookingAnchor() {
    return (
      document.getElementById('book-meeting') ||
      document.querySelector('[data-bookx-quote-anchor="true"]') ||
      null
    );
  }

  document.addEventListener('DOMContentLoaded', function mountQuoteBookingBridge() {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    const data = safeParse(raw);
    if (!data || typeof data.email !== 'string' || data.email.trim() === '') {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    /** @type {HTMLElement | null} */
    const anchor = findBookingAnchor();

    sessionStorage.removeItem(STORAGE_KEY);

    if (!(anchor instanceof HTMLElement)) return;

    const emailEsc = escapeHtml(data.email.trim());
    const summary =
      typeof data.productSummary === 'string' && data.productSummary.trim()
        ? escapeHtml(data.productSummary.trim())
        : 'your selected products';

    const banner = document.createElement('div');
    banner.className = 'quote-booking-bridge-banner';
    banner.setAttribute('role', 'status');
    banner.innerHTML =
      `<p>Your quote for <strong>${summary}</strong> was sent to our team.</p>` +
      `<span class="quote-booking-bridge-banner__hint">Book your time slot below using the same email:&nbsp;<strong>${emailEsc}</strong></span>` +
      `<button type="button" class="quote-booking-bridge-banner__dismiss" data-quote-banner-dismiss>Dismiss</button>`;

    const dismissBtn = banner.querySelector('[data-quote-banner-dismiss]');
    dismissBtn?.addEventListener('click', () => banner.remove());

    anchor.insertAdjacentElement('afterbegin', banner);

    /** Scroll anchor into view when landing with hash */
    const hash = (window.location.hash || '').toLowerCase();
    if (hash === '#schedule' || hash === '#bookx') {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /** Auto-open Calendly after quote submission */
    if (typeof window.HakeemOpenCalendly === 'function') {
      window.setTimeout(function () {
        window.HakeemOpenCalendly();
      }, 400);
    }
  });
})();
